import { takeLatest } from 'redux-saga';
import { put, call, fork } from 'redux-saga/effects';

import { authService } from '../../utils/auth-service';
import { processCampaignInvitation, getCampaignInvitationAxios } from '../../utils/jsonapi-functions/campaign-invitations';
import { reportError } from '../../utils/error-handling-service';

import {
  LOAD_CAMPAIGN_INVITE,
  LOAD_CAMPAIGN_INVITE_ERROR,
  SET_SIGNUP_PREFILLED,
  SET_LOGIN_PREFILLED,
} from './constants';

function* processInvites(invites) {
  yield invites.map(inviteId => call(processCampaignInvitation, inviteId));
}

export function redirectUser(changeUrlCallback) {
  const path = localStorage.getItem('path');
  if (path) {
    changeUrlCallback(path);
    localStorage.removeItem('path');
  } else {
    changeUrlCallback('/');
  }
}

export function* loadCampaignInvite(action) {
  const { changeUrlCallback, urlInviteId } = action.data;

  const loggedIn = authService.loggedIn();

  try {
    // Nothing to process, redirect to homepage
    if (!loggedIn && !urlInviteId) {
      changeUrlCallback('/');
    }

    // Process logged in user with invite ID
    if (loggedIn && urlInviteId) {
      yield call(processCampaignInvitation, urlInviteId);
      changeUrlCallback('/');
    }

    // Look for user in invitations to see if they accepted any invitations
    if (loggedIn && !urlInviteId) {
      const campaignInvites = localStorage.getItem('campaignInvitesToProcess');
      if (campaignInvites) {
        const campaignInvitesArray = JSON.parse(campaignInvites);

        try {
          yield call(processInvites, campaignInvitesArray);
        } catch (error) {
          reportError('CREATE_CAMPAIGN_PERMISSION_ERROR', error.message);
        }
        localStorage.removeItem('campaignInvitesToProcess');
      }
      redirectUser(changeUrlCallback);
    }

    // Set the invitation as accepted for when the user signs up or logs in
    if (!loggedIn && urlInviteId) {
      const campaignInvitation = yield call(getCampaignInvitationAxios, urlInviteId);
      const { name, email, newUser } = campaignInvitation;

      const campaignInvites = localStorage.getItem('campaignInvitesToProcess');

      if (!campaignInvites) {
        localStorage.setItem('campaignInvitesToProcess', JSON.stringify([urlInviteId]));
      } else {
        const campaignInvitesArray = JSON.parse(campaignInvites);
        const idExists = campaignInvitesArray.find(inviteId => inviteId === urlInviteId);
        if (!idExists) campaignInvitesArray.push(urlInviteId);
        localStorage.setItem('campaignInvitesToProcess', JSON.stringify(campaignInvitesArray));
      }

      if (newUser) {
        yield put({ type: SET_SIGNUP_PREFILLED, shortId: urlInviteId, name, email });
        changeUrlCallback('/signup');
      } else {
        yield put({ type: SET_LOGIN_PREFILLED, email });
        changeUrlCallback('/login');
      }
    }
  } catch (error) {
    reportError('CREATE_CAMPAIGN_PERMISSION_ERROR', error.message);

    yield put({ type: LOAD_CAMPAIGN_INVITE_ERROR, error: error.message });
  }
}

export function* watchLoadCampaignInviteSagas() {
  yield takeLatest(LOAD_CAMPAIGN_INVITE, loadCampaignInvite);
}

export default function* loadCampaignInviteSagas() {
  yield [
    fork(watchLoadCampaignInviteSagas),
  ];
}



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-invite/sagas.js
 **/